import React from 'react';
import { __ } from '@wordpress/i18n';
import { JobResult } from '../types/job';
import { getListingBaseUrl } from '../facet/urlLocale';

interface Props {
  result: JobResult;
}

const JobCard: React.FC<Props> = ({ result }) => {
  const jobId = result.job_id?.raw || '';
  const jobTitle = result?.job_title?.raw ?? __('No Title', 'wp-plugin-jobs');
  const location = result?.location?.raw ?? __('No Location', 'wp-plugin-jobs');
  const friendlySalary = result?.friendly_salary?.raw;
  const salary = result?.salary?.raw ?? '';
  const offsitePreference = result?.offsite_preference?.raw ?? null;
  const postedDate = result?.posted_date?.raw ?? null;
  const dateLocale = (window.aqJobsOptions?.locale || 'en-US').replace('_', '-');
  const formattedDate = postedDate
    ? new Date(postedDate).toLocaleDateString(dateLocale, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC',
    })
    : __('No Date', 'wp-plugin-jobs');
  const jobLink = `${getListingBaseUrl()}/${jobId}`;
  const base = 'job-card';
  const title = jobTitle.replace(/<\/?em>/g, '');
  const classes = {
    wrapper: base,
    block: `${base}__block`,
    title: `${base}__title`,
    location: `${base}__location`,
    salary: `${base}__salary`,
    separator: `${base}__separator`,
    time: `${base}__time`,
  };
  // Check if the job is new (posted within the last 7 days)
  const isNewJob = (date) => {
    const postedDateObj = new Date(date);
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    return postedDateObj >= sevenDaysAgo;
  };

  return (
    <a href={jobLink} title={title} className={classes.wrapper}>
      <div className={classes.block} role="region" aria-labelledby={`job-title-${jobId}`}>
        <h2 className={classes.title} id={`job-title-${jobId}`}>{jobTitle.replace(/<\/?em>/g, '')}</h2>
        <p className={classes.location}>
          {location} {offsitePreference && location !== offsitePreference && (<>
            <span className={classes.separator}> | </span> {offsitePreference}
          </>
          )}
        </p>
        {friendlySalary ? (
          <p className={classes.salary}>{friendlySalary}</p>
        ) : (
          <p className={classes.salary}>{salary}</p>
        )}
        <time
          className={`${classes.time} ${isNewJob(result.posted_date?.raw) ? 'job-card__posted--new' : ''}`}
          itemProp="datePublished"
        >
          {__('Posted', 'wp-plugin-jobs')} {formattedDate}
        </time>
      </div>
    </a>

  );
};
export default JobCard;
